import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEvArticle } from 'site-modules/editorial/utils/ev';
import { ReadyForEv } from 'site-modules/shared/components/ready-for-ev/ready-for-ev';

export function ArticleReadyForEv({
  categories = [],
  slug,
  className = null,
  headingStyles = null,
  wrapperStyles = null,
}) {
  if (!isEvArticle({ slug, categories })) {
    return null;
  }

  return (
    <div className={classnames('article-ready-for-ev bg-cool-gray-90 px-1 py-1 rounded-12', className)}>
      <ReadyForEv
        heading="Am I Ready for an EV?"
        className="bg-white rounded-12 px-1_5 py-1_5"
        hideCta
        headingStyles={headingStyles}
        wrapperStyles={wrapperStyles}
      />
    </div>
  );
}

ArticleReadyForEv.propTypes = {
  slug: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  headingStyles: PropTypes.shape({}),
  wrapperStyles: PropTypes.shape({}),
};
